// extracted by mini-css-extract-plugin
export default {"root":"Heus4fi1s08vtTZwsFMU"};